// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AttackIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AttackIcon" ref={forwardedRef} {...props}>
      <path d="M18.319 18.4H1.75v-3.217A3.2 3.2 0 0 1 2.624 13c.563-.602 1.16-.999 2.002-1.097L2.88 9.287A1.87 1.87 0 0 1 2.626 8.35 1.87 1.87 0 0 1 2.88 7.41l5.378-5.467A3.8 3.8 0 0 1 10.04 1.5a3.8 3.8 0 0 1 1.781.443L17.19 7.41a1.64 1.64 0 0 1 .296.939 1.64 1.64 0 0 1-.296.938l-1.78 2.616c.833.11 1.507.512 2.057 1.113a3.2 3.2 0 0 1 .853 2.167zM4.429 8.854l2.384 3.924c-2.385 0-3.496 1.306-3.496 1.842v2.28h13.435v-2.28c0-.612-1.545-1.842-3.455-1.842.156-.266.492-.824.905-1.512a745 745 0 0 0 1.343-2.24c.247-.357.174-.832-.326-1.364-1.226-1.307-3.271-3.488-4.091-4.396-.331-.366-1.885-.32-2.183 0A612 612 0 0 1 4.82 7.662C4.217 8.285 4.34 8.618 4.428 8.854" />
      <path d="M6.429 6.249a22 22 0 0 1 7.211 0v3.384a3.5 3.5 0 0 1-.883 2.343c-.563.622-1.326.972-2.122.974H9.376a2.7 2.7 0 0 1-1.138-.258 3 3 0 0 1-.96-.723 3.3 3.3 0 0 1-.635-1.074 3.6 3.6 0 0 1-.212-1.262zm1.48 1.314.002 1.995a2.1 2.1 0 0 0 .125.744 2 2 0 0 0 .374.633 1.75 1.75 0 0 0 .566.425 1.6 1.6 0 0 0 .67.153h.742a1.7 1.7 0 0 0 1.25-.574 2.07 2.07 0 0 0 .521-1.381V7.563a13 13 0 0 0-4.25 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AttackIcon = /* @__PURE__ */ Object.assign(AttackIconComponent, {
  displayName: 'AttackIcon',
});
